import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { TestimonyContainer, TestimonyImage, TestimonyText } from './testimony.styles';

interface TestimonyProps {
  image: IGatsbyImageData;
  text: string;
  personName: string;
}

const Testimony = ({ image, text, personName }: TestimonyProps): JSX.Element => {
  return (
    <TestimonyContainer>
      <FadeInAnimationWrapper>
        <TestimonyImage>
          <Image childImageSharp={image} alt={personName} />
        </TestimonyImage>
        <TestimonyText>
          <Paragraph
            text={text}
            size="1.75em"
            sizeLg="1.35em"
            sizeSubMd="1.2em"
            weight="light"
          />
          <Heading
            text={personName}
            size="1.75em"
            sizeLg="1.2em"
            sizeSubMd="1.2em"
            weight="normal"
            align="left"
          />
        </TestimonyText>
      </FadeInAnimationWrapper>
    </TestimonyContainer>
  )
}

export default Testimony;
